var a = 400
const productQuery = `
    {
      collections(first: 100) {
        nodes {
          products(first: 10, filters: {price: {max: `+ a + `, min: 0}}, sortKey: PRICE) {
            nodes {
              productType
              priceRange {
                maxVariantPrice {
                  amount
                  currencyCode
                }
                minVariantPrice {
                  amount
                  currencyCode
                }
              }
            }
          }
          handle
        }
      }
    }
  `;
// var result = graphQLUtils(productQuery).then(res => {
//     console.log(res,'res')
// });
// console.log('aaa',result)
// console.log('result',result.then(res => {
//     console.log(res)
// }));